export default __webpack_public_path__ + "static/media/q-maturity.02745eb1.svg";